import React, { useEffect, useState } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import User from './User';
import '../index.css';

const MyAccount = () => {

   const [loadingData, setLoadingData] = useState(true);
    const [data,setData] = useState([]);
   
    useEffect(() => {
        async function  getData(){
            axios.get(`https://innounita.univ-unita.eu/backend/companies/my-company`)
            .then((response) => {
                setData(response.data)
                console.log(response)
            });
            while (User.isLoading){
                await new Promise(resolve => setTimeout(resolve, 2));
            }
            setLoadingData(false)
        }
       
        if (loadingData) {
            getData();
        }
    },[]);

    const editButton = () => {
        var isAdmin = false;
        for(var grantedAuthority of User.authorities){
            if (grantedAuthority.authority === "ROLE_ADMIN" || grantedAuthority.authority === "ROLE_UNIVERSITY" || data.email === User.data.username){
                isAdmin = true;
                break;
            }
        }

        if(isAdmin){
            return (<div style={{ "textAlign" : "center" }}><Link to={`/companies/${data.id}/edit`}><button className="ui button primary">Edit</button></Link></div>)
        }
        return;
    }

    console.log(data)
    return (
        <div className="login-body">
            <div className="ui container">
                <div className="login-background">
                    <div className="ui left aligned container login-field">
                       <div style={{ "textAlign" : "center" }}> <img src={data.logo} height='50px' alt='logo'></img> </div>
                       <div style={{ "textAlign" : "center" }}><h1>{data.name}</h1></div>
                       <br/>
                       <br/>
                       <br/>
                       <br/>
                       <div>Contact Person: {data.contactPersonName}</div>
                       <div>Contact Person Role: {data.contactPersonRole}</div>
                       <div>Email: {data.email}</div>
                       <div>Year Founded: {data.yearFounded}</div>
                       <div>University: {data.university}</div>
                       <div>Website: <a href={data.website}>{data.website}</a></div>
                       <div>Location: {data.geoLocationCoordinates}</div>
                       <div>Countries: {data.countries}</div>
                       <div>NACE: {data.mainNACE}</div>
                       <div>Company Activity: {data.companyActivity}</div>
                       <div>Business Model: {data.bussinessModel}</div>
                       <div>Employee Count: {data.employeeCount}</div>
                       <div>Initial Country: {data.initialCountry}</div>
                       <div>Turnover: {data.turnoverN}</div>
                       <div>TurnoverN1: {data.turnoverN1}</div>
                       <div>TurnoverN2: {data.turnoverN2}</div>
                       <div>TurnoverN3: {data.turnoverN3}</div>
                       <div>TurnoverN4: {data.turnoverN4}</div>
                       <div>Revenue: {data.preRevenue}</div>
                       <div>Entreprenourship: {data.entreprenourship}</div>
                       <div>Innovation: {data.innovationEducation}</div>
                       <div>Mentorship: {data.mentorship}</div>
                       <div>Incubation Services: {data.incubationServices}</div>
                       <div>Acceleration Services: {data.accelerationServices}</div>
                       <div>Funding Provided: {data.fundingProvided}</div>
                       <div>collaborativeRDP: {data.collaborativeRDP}</div>
                       <div>Patent: {data.patent}</div>
                       <div>Internship: {data.internship}</div>
                       <div>Spinoff: {data.spinoff}</div>
                       <div>Founders Are Alumni: {data.foundersAreAlumni}</div>
                       <div>Percentage Employee Alumni: {data.percentageEmployeeAlumni}</div>
                       <div>Percentage Employee Tertiary Ed: {data.percentageEmployeeTertiaryEd}</div>
                       <div>Percentage Employee PHD: {data.percentageEmployeePHD}</div>
                       <div>Num Scientific Copublications: {data.numScientificCopublications}</div>
                       <div>Percentage RD Expediture: {data.percentageRDExpediture}</div>
                       <div>Has Innovations: {data.hasInnovations}</div>
                       <div>Has Intelectual Assets: {data.hasIntelectualAssets}</div>
                       <div>Aligned UNSDG: {data.alignedUNSDG}</div>
                       <div>Generating Periodical Report: {data.generatingPeriodicalReport}</div>
                       <div>Has Raised Investment Round: {data.hasRaisedInvestmentRound}</div>
                       <div>Has Raised Nondillutive Founding: {data.hasRaisedNonDillutiveFounding}</div>
                       <div>Entrepreneurial Booster Scheme: {data.entrepreneurialBoosterScheme}</div>
                       <div>CEO is Woman: {data.isCEOWoman}</div>
                       <br/>
                       <br/>
                       {editButton()}
                    </div>
                </div>
            </div>
        </div>
        );
}


export default MyAccount;